import { Check } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { APP_LOGO, APP_NAME, APP_TAGLINE } from '../ui/appBrand';

/**
 * Shared full-screen, two-panel shell for the sign-in / sign-up pages.
 * Left: brand showcase (desktop only). Right: the form (passed as children).
 */
const AuthLayout = ({ title, subtitle, children, footer }) => {
  const { t } = useTranslation();

  const FEATURES = [
    t('feature_time_tracking'),
    t('feature_scheduling'),
    t('feature_payroll'),
    t('feature_compliance'),
  ];

  return (
    <div className="auth-shell">
      <aside className="auth-brand">
        <div className="auth-brand-bg" aria-hidden="true" />
        <div className="auth-brand-inner">
          <div className="auth-brand-lockup">
            <img src={APP_LOGO} alt={APP_NAME} className="auth-brand-logo" />
            <div>
              <div className="auth-brand-name">{APP_NAME}</div>
              <div className="auth-brand-tagline">{APP_TAGLINE}</div>
            </div>
          </div>

          <h1 className="auth-brand-headline">{t('manage_team_headline')}</h1>
          <p className="auth-brand-copy">
            {t('manage_team_description')}
          </p>

          <ul className="auth-feature-list">
            {FEATURES.map((feature) => (
              <li key={feature} className="auth-feature">
                <span className="auth-feature-check">
                  <Check size={14} strokeWidth={3} />
                </span>
                {feature}
              </li>
            ))}
          </ul>

          <div className="auth-social-proof">
            <div className="auth-social-stars" aria-hidden="true">★★★★★</div>
            <p className="auth-social-quote">
              {t('auth_testimonial', {
                defaultValue:
                  '“Clock-ins, scheduling and payroll finally live in one place. It replaced three separate tools for us.”',
              })}
            </p>
            <p className="auth-social-by">
              {t('auth_testimonial_by', { defaultValue: '— A ZonStaff business owner' })}
            </p>
          </div>
        </div>
      </aside>

      <main className="auth-form-panel">
        <div className="auth-form-wrap">
          <div className="auth-form-head">
            <img src={APP_LOGO} alt={APP_NAME} className="auth-form-logo" />
            <h2 className="auth-form-title">{title}</h2>
            <p className="auth-form-subtitle">{subtitle}</p>
          </div>

          {children}

          {footer && <div className="auth-form-footer">{footer}</div>}
        </div>
      </main>
    </div>
  );
};

export default AuthLayout;
